export default "__VITE_ASSET__Dsyroqa6__"